<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    item-text="title"
    :items="divisions"
    item-value="id"
    @change="onChange"
    v-on:input="$emit('input', $event)"
    @update:search-input="update"
    :loading="loading"
    clearable
    :hide-details="hideDetails"
  ></v-autocomplete>
</template>

<script>
import { Division } from '@/plugins/api'
import utils from '@/plugins/utils.js'

export default {
  data: () => ({
    divisions: [],
    loading: false,
  }),
  props: {
    filter: Object,
    defaultDivisions: Object,
    options: Object,
    hideDetails: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
  created() {
    if (this.defaultDivisions) {
      this.divisions = this.defaultDivisions
    }

    this.fetchAllDivisions()
  },
  methods: {
    async fetchAllDivisions() {
      this.loading = true
      this.divisions = await Division.fetch({
        ...this.filter,
        _limit: -1,
      })
      if (this.divisions.length === 0) {
        this.$alert.error(`Bộ môn ${this.title} không có chương trình đào tạo`)
      }
      this.divisions = this.divisions.sort((a, b) => utils.sortAlphabetVietnamese(a.title, b.title))
      this.loading = false
    },
    async update() {},
    onChange(data) {
      this.$emit('change', data)
    },
  },
  watch: {
    filter() {
      this.fetchAllDivisions()
    },
  },
}
</script>

<style scoped></style>
